import buildModuleCreate from './create.js'
import moduleEditItem from './module-edit-item.js'
import Vue from 'vue'

export const SET_LOADING = 'SET_LOADING'
export const SET_ERROR = 'SET_ERROR'
export const ADD_CHILD = 'ADD_CHILD'
export const DEL_CHILD = 'DEL_CHILD'
export const REM_CHILD = 'REM_CHILD'
export const DELETED_CHILD = 'DELETED_CHILD'
export const REPLACE_CHILD = 'REPLACE_CHILD'
export const MOVE_CHILD = 'MOVE_CHILD'

/**
 * Abstract base for composite editing.
 *
 * @return {{mutations: {}, state: {}, getters: {}, actions: {}, namespaced: boolean, modules}}
 */
export default function buildModuleComposite (base, path, properties, childCreateUrl, childCreateProperties, childUpdateProperties, parsed, prepareChild) {

  const makeLocalChildName = (childNameOrPath) => {
    if (childNameOrPath.substring(0, path.length) === path) {
      return childNameOrPath.substring(path.length + 1)
    }
    return childNameOrPath
  }

  return moduleEditItem({
    namespaced: true,
    state: {
      ...base.state,
      error: '',
      isLoading: false,
      childSlots: [],
      slotsToUpdate: [],
      slotsToAdd: [],
      idsToDelete: [],
    },
    actions: {
      ...base.actions,
      addChild ({dispatch, commit, getters}) {
        return new Promise((resolve => {
          let child = getters.childSlots.length
          while (getters.childSlots.indexOf('child' + child) !== -1) {
            child++
          }
          const childName = 'child' + child
          commit(ADD_CHILD, childName)
          this.registerModule(path + '/' + childName, buildModuleCreate(childCreateProperties, childCreateUrl, parsed))
          dispatch(childName + '/clear').then((newItem) => {
            dispatch(childName + '/setItem', prepareChild(newItem, getters.item)).then(() => {
              resolve(childName)
            })
          })
        }))
      },
      removeChild ({dispatch, commit, getters, rootGetters}, childName) {
        childName = makeLocalChildName(childName)
        const id = getters[childName + '/item']['@id']
        if (id) {
          commit(DEL_CHILD, id)
        }
        this.unregisterModule(path + '/' + childName)
        commit(REM_CHILD, childName)
        // dispatch('updateItem', {
        //   [childProperty]: getters.item[childProperty].filter(test => {
        //     return test !== id
        //   })
        // })
      },
      moveChild ({commit}, {childName, position}) {
        commit(MOVE_CHILD, {childName: makeLocalChildName(childName), position})
      }
    },
    getters: {
      ...base.getters,
      error: state => state.error,
      isLoading: state => state.isLoading,
      childSlots: state => state.childSlots,
      idsToDelete: state => state.idsToDelete,
    },
    mutations: {
      ...base.mutations,
      [SET_ERROR] (state, error) {
        Object.assign(state, { error })
      },
      [SET_LOADING] (state, isLoading) {
        Object.assign(state, { isLoading })
      },
      [ADD_CHILD] (state, slotName) {
        const childSlots = state.childSlots
        childSlots.push(slotName)
        Vue.set(state, {childSlots})
      },
      [REM_CHILD] (state, slotName) {
        state.childSlots = state.childSlots.filter((test) => test !== slotName)
      },
      [MOVE_CHILD] (state, {childName, position}) {
        const oldPosition = state.childSlots.indexOf(childName)
        if (position >= state.childSlots.length) {
          position = state.childSlots.length
        }
        state.childSlots.splice(position, 0, state.childSlots.splice(oldPosition, 1)[0]);
      },
      [DEL_CHILD] (state, id) {
        state.idsToDelete.push(id)
      },
      [REPLACE_CHILD] (state, {oldName, newName}) {
        state.childSlots = state.childSlots.map((test) => test === oldName ? newName : test)
      },
      [DELETED_CHILD] (state, {childId}) {
        state.idsToDelete = state.idsToDelete.filter((test) => test === childId)
      },
    }
  }, {properties, parsed})
}
